import type { IconProps } from '../types/IconProps.ts';
export const Rows2: IconProps = {
    name: 'Rows2',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="M3 12h18" />`,
    ]
};